import _ from 'lodash';
import * as moment from 'moment-timezone';

import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class TimeZoneService {

  public list = [];

  constructor() { }

  updateTimeZoneList(timestamp) {
    const zones = moment.tz.names();
    this.list = _.chain(zones).map((name, index) => {
      const offset = moment.tz.zone(name).utcOffset(timestamp);
      const gmt = `GMT ${moment.tz(timestamp, name).format('Z')}`;
      let abbr = moment.tz(timestamp, name).format('z');
      if(abbr.match(/[\+\-][0-9]+/) !== null) {
        abbr = gmt;
      }
      const label = `(${gmt}) ${name} - ${abbr}`;
      return { index, label, value: name, offset };
    }).sortBy('offset').value();
  }
}
